module.exports = __webpack_public_path__ + "static/contact-00a62c31929be700383e39c05f25f7e6.png";